/* eslint-disable max-len */
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyTooltipModule as MatTooltipModule } from '@angular/material/legacy-tooltip';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacySlideToggleModule as MatSlideToggleModule } from '@angular/material/legacy-slide-toggle';
import { MatTreeModule } from '@angular/material/tree';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyRadioModule as MatRadioModule } from '@angular/material/legacy-radio';
import { XpoGridToolbar, XpoGridToolbarProjectContentComponent } from './toolbar.component';
import { XpoGridToolbarActions } from './toolbar-actions/toolbar-actions.component';
import { XpoGridToolbarDynamicMore, XpoBoardGridToolbarActionsMore } from './toolbar-actions/toolbar-dynamic-more/toolbar-dynamic-more.component';
import { XpoGridToolbarToggleButtonsGroup } from './toolbar-toggle/toggle-group.component';
import { XpoGridToolbarSettings } from './toolbar-settings/toolbar-settings.component';
import { XpoSelectModule } from '@xpo-ltl/ngx-ltl-core/select';
import { XpoUtilsModule } from '@xpo-ltl/ngx-ltl-core/utils';
import { XpoDownloadButtonModule } from '@xpo-ltl/ngx-ltl-core/download-button';
import { XpoButtonModule } from '@xpo-ltl/ngx-ltl-core/button';
import { XpoIconModule } from '@xpo-ltl/ngx-ltl-core/icon';

@NgModule({
  declarations: [
    XpoGridToolbar,
    XpoGridToolbarActions,
    XpoBoardGridToolbarActionsMore,
    XpoGridToolbarDynamicMore,
    XpoGridToolbarToggleButtonsGroup,
    XpoGridToolbarSettings,
    XpoGridToolbarProjectContentComponent,
  ],
  imports: [
    MatIconModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatSelectModule,
    XpoSelectModule,
    CommonModule,
    MatSlideToggleModule,
    FormsModule,
    MatMenuModule,
    MatTooltipModule,
    MatIconModule,
    MatButtonModule,
    MatRadioModule,
    MatCheckboxModule,
    XpoUtilsModule,
    XpoDownloadButtonModule,
    XpoButtonModule,
    MatTreeModule,
    MatFormFieldModule,
    XpoIconModule,
  ],
  exports: [
    XpoGridToolbar,
    XpoGridToolbarActions,
    XpoBoardGridToolbarActionsMore,
    XpoGridToolbarDynamicMore,
    XpoGridToolbarToggleButtonsGroup,
    XpoGridToolbarSettings,
    XpoGridToolbarProjectContentComponent,
  ],
})
export class XpoGridToolbarModule {}
